module.exports = __webpack_public_path__ + "images/item_icons/boatAdminLogo.e614ad6035833ec130a89ee7061c930e.svg";